"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodcastSearch = void 0;
var PodcastSearch = (function () {
    function PodcastSearch() {
        this.programName = document.querySelector("#programName");
        if (this.programName) {
            this.programName.addEventListener('keyup', this.searchPodcasts);
        }
    }
    PodcastSearch.getInstance = function () {
        if (!this.instance) {
            this.instance = new PodcastSearch();
        }
        return this.instance;
    };
    PodcastSearch.prototype.searchPodcasts = function () {
        this.programName = document.querySelector("#programName");
        var introductionTeasers = document.querySelectorAll('.teaser-list .introduction-teaser');
        for (var i = 0; i < introductionTeasers.length; i++) {
            var podcastName = introductionTeasers[i].querySelector("h2").textContent;
            var podcastIntro = introductionTeasers[i].querySelector(".intro").textContent;
            if (podcastName.toUpperCase().indexOf(this.programName.value.toUpperCase()) > -1 ||
                podcastIntro.toUpperCase().indexOf(this.programName.value.toUpperCase()) > -1) {
                introductionTeasers[i].style.display = "";
            }
            else {
                introductionTeasers[i].style.display = "none";
            }
        }
    };
    return PodcastSearch;
}());
exports.PodcastSearch = PodcastSearch;
